import { defaultIconSize } from '@synqo/frontend-component-library';
import { type Icon, IconCircleCheck, IconMessageReport } from '@tabler/icons-react';
import { type FC, Fragment, type PropsWithChildren } from 'react';
import classes from './ColumnValue.module.css';

export type ColumnValueVariant = 'default' | 'danger' | 'success';

const variantToIconMap: Record<ColumnValueVariant, Icon | typeof Fragment> = {
    default: Fragment,
    danger: IconMessageReport,
    success: IconCircleCheck,
};

export interface ColumnValueProps extends PropsWithChildren {
    variant?: ColumnValueVariant;
    noIcon?: boolean;
}

export const ColumnValue: FC<ColumnValueProps> = ({ children, variant = 'default', noIcon = false }) => {
    const IconComponent = noIcon ? Fragment : variantToIconMap[variant];

    return (
        <span className={classes.root} data-variant={variant}>
            {IconComponent !== Fragment && (
                <>
                    <IconComponent size={defaultIconSize} />
                    {'\u00A0'}
                </>
            )}
            {children}
        </span>
    );
};
